// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"163":"map","251":"begeleider-setup","688":"student-setup","930":"setup"}[chunkId] || chunkId) + "." + {"163":"94bb73f4","251":"f94902be","365":"6badffd1","688":"81a7423d","930":"22a6f1bc"}[chunkId] + ".js";
};